import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/research',
    name: 'Research',
    component: () => import('@/views/Research.vue')
  },
  {
    path: '/people',
    name: 'People',
    component: () => import('@/views/People.vue')
  },
  {
    path: '/publications',
    name: 'Publication',
    component: () => import('@/views/Publication.vue')
  },
  {
    path: '/protocols',
    name: 'Protocol',
    component: () => import('@/views/Protocol.vue')
  },
  {
    path: '/album',
    name: 'Album',
    component: () => import('@/views/Album.vue')
  },
  {
    path: '/album/:albumId',
    name: 'Picture',
    component: () => import('@/views/Picture.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News.vue')
  },
  {
    path: '/join',
    name: 'Join',
    component: () => import('@/views/Join.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
